'use strict';
import React from 'react';
import ReportModal from './reportModal';
import reportAction from '../../actions/reportAction';
import reportStore from '../../stores/reportStore';
import { callbackify } from 'util';

class ReportList extends React.Component {
    constructor(props) {
        super(props);
        this.handleReportClick = this.handleReportClick.bind(this);
        this.extendIncident = this.extendIncident.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.resolveIncident = this.resolveIncident.bind(this);
        this.addingRemark = this.addingRemark.bind(this);
        this.removeIncident = this.removeIncident.bind(this);
        this.showOption = this.showOption.bind(this);
        this.closeOption = this.closeOption.bind(this);
        this.handleOption = this.handleOption.bind(this);
        this.onChange = this.onChange.bind(this);
        this.state = {
            action: 0,
            modalClose: false,
            reportId: "",
            title: "",
            clientEmail: [],
            processing: reportStore.getState().processing,
        };
    }

    static defaultProps = {
        mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        severityTxt: ["Low", "Medium", "High", "Critical"],
        statusTxt: ["Closed", "Open", "Removed"],
    }
    componentDidMount() {
        reportStore.listen(this.onChange);
        window.addEventListener("click", this.closeOption);
    }
    componentWillUnmount() {
        reportStore.unlisten(this.onChange);
        window.removeEventListener("click", this.closeOption);
    }
    onChange(state) {
        this.setState({
            processing: state.processing
        })
    }
    showOption(e) {
        e.preventDefault();
        e.stopPropagation();
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        index = index + this.props.page * this.props.contentNo;
        reportAction.shouldListShow(index);
    }
    closeOption() {
        reportAction.closeListShow();
    }
    handleOption(e) {
        e.preventDefault();
        e.stopPropagation();

        let action = parseInt(e.currentTarget.getAttribute("data-action"));
        let reportId = e.currentTarget.getAttribute('data-id');
        let index = parseInt(e.currentTarget.getAttribute('data-index'));

        let title;
        if (action == 0) {
            title = "Extend Target Date";
        } else if (action == 1) {
            title = "Resolution";
        } else if (action == 2) {
            title = "Add Remark";
        } else {
            title = "Delete Incident";
        }
        let clientEmail = this.props.reports[index].clientEmail;

        reportAction.shouldListShow(index);

        this.setState({
            action: 0,
            modalClose: true,
            reportId: reportId,
            action: action,
            title: title,
            clientEmail: clientEmail,
        });
    }

    extendIncident(day, reason, clientEmail, reportImage) {
        if (this.state.processing) return;
        reportAction.processing(true);
        let fd = new FormData();
        fd.append("day", day);
        fd.append("reason", reason);
        if (clientEmail) {
            if (clientEmail.length > 0) {
                for (let i = 0; i < clientEmail.length; i++) {
                    fd.append("clientEmail[]", clientEmail[i]);
                }
            }
        }
        if (reportImage) {
            if (reportImage.length > 0) {
                for (let i = 0; i < reportImage.length; i++) {
                    fd.append("images", reportImage[i]);
                }
            }
        }
        reportAction.extendIncident(this.state.reportId, fd);
        this.shouldModalClose(false);
    }
    resolveIncident(resolution, value, clientEmail, reportImage) {
        if (this.state.processing) return;
        reportAction.processing(true);
        let fd = new FormData();
        fd.append("resolution", resolution);
        if (clientEmail) {
            if (clientEmail.length > 0) {
                for (let i = 0; i < clientEmail.length; i++) {
                    fd.append("clientEmail[]", clientEmail[i]);
                }
            }
        }
        if (reportImage) {
            if (reportImage.length > 0) {
                for (let i = 0; i < reportImage.length; i++) {
                    fd.append("images", reportImage[i]);
                }
            }
        }
        reportAction.resolveIncident(this.state.reportId, fd);
        this.shouldModalClose(false);
    }
    addingRemark(remark, value, clientEmail, reportImage) {
        if (this.state.processing) return;
        reportAction.processing(true);

        let fd = new FormData();
        fd.append("remark", remark);
        if (clientEmail) {
            if (clientEmail.length > 0) {
                for (let i = 0; i < clientEmail.length; i++) {
                    fd.append("clientEmail[]", clientEmail[i]);
                }
            }
        }
        if (reportImage) {
            if (reportImage.length > 0) {
                for (let i = 0; i < reportImage.length; i++) {
                    fd.append("images", reportImage[i]);
                }
            }
        }
        reportAction.addingRemark(this.state.reportId, fd);
        this.shouldModalClose(false);
    }
    removeIncident(reason, value, clientEmail, reportImage) {
        if (this.state.processing) return;
        reportAction.processing(true);
        reportAction.removeIncident(this.state.reportId, this.state.clientEmail, reason);
        this.shouldModalClose(false);
    }
    shouldModalClose(data) {
        this.setState({
            modalClose: data
        });
    }
    handleReportClick(e) {
        let reportId = e.currentTarget.getAttribute('data-id');
        this.props.history.push('/report/' + reportId);
    }

    renderDataList(report, index) {
        report.date = new Date(report.date);
        report.targetDate = new Date(report.targetDate);
        let date = report.date.getDate() + "-" + this.props.mthTxt[report.date.getMonth()] + "-" + report.date.getFullYear();
        let targetDate = report.targetDate.getDate() + "-" + this.props.mthTxt[report.targetDate.getMonth()] + "-" + report.targetDate.getFullYear();
        let day = this.props.dayTxt[report.date.getDay()];
        let extend = report.extend.length > 0 ? report.extend[report.extend.length - 1].day : "--";
        let reason = report.extend.length > 0 ? report.extend[report.extend.length - 1].reason : "--";
        let remark = report.remarks.length > 0 ? report.remarks[report.remarks.length - 1].remark : "--";

        return (
            <tr key={index} >
                <td data-id={report.reportNo} onClick={this.handleReportClick}>{report.reportNo}</td>
                <td>{date}</td>
                <td>{day}</td>
                <td>{report.userName}</td>
                <td>{report.condoName}</td>
                <td>{report.mcst}</td>
                <td>{report.facility}</td>
                <td>{report.category}</td>
                <td className="rpt-t">{report.description}</td>
                <td>{this.props.severityTxt[report.severity]}</td>
                <td>{targetDate}</td>
                <td>{extend}</td>
                <td>{reason}</td>
                <td>{this.props.statusTxt[report.status]}</td>
                <td>{report.resolution}</td>
                <td>{report.resolvedBy}</td>
                <td>{remark}</td>
                <td data-index={index} onClick={this.showOption}>
                    {report.status == 1 ?
                        <span className="rpt-edit glyphicon glyphicon-option-vertical" ></span>
                        : ""}
                    {this.renderEdit(index, report)}
                </td>
            </tr>

        );

    }

    renderEdit(index, report) {
        if (report.status == 1) {
            return (
                <ul className={"rpt-dropdown " + (report.shouldListShow ? "rpt-show" : "rpt-hide")} >
                    <li data-action="0" data-id={report._id} data-index={index} onClick={this.handleOption}>Extend Target Date</li>
                    <li data-action="1" data-id={report._id} data-index={index} onClick={this.handleOption}>Resolved</li>
                    <li data-action="2" data-id={report._id} data-index={index} onClick={this.handleOption}>Add Remark</li>
                    <li data-action="3" data-id={report._id} data-index={index} onClick={this.handleOption}>Remove</li>
                </ul>
            );
        }
    }
    renderMainList() {
        return this.props.reports.map((report, index) => {
            if (report) {
                return (
                    this.renderDataList(report, index)
                );
            }
        });
    }

    render() {
        let callBack;
        if (this.state.action == 0) {
            callBack = this.extendIncident;
        } else if (this.state.action == 1) {
            callBack = this.resolveIncident;
        } else if (this.state.action == 2) {
            callBack = this.addingRemark;
        } else {
            callBack = this.removeIncident;
        }
        let modal;
        if (this.state.modalClose) {
            modal = (
                <ReportModal
                    action={this.state.action}
                    callBack={callBack}
                    shouldModalClose={this.shouldModalClose}
                    modalClose={this.state.modalClose}
                    title={this.state.title}
                    clientEmail={this.state.clientEmail}
                />
            );
        }
        return (
            <div className="atd-abd-wp">
                <div className="atd-em-lt">
                    <table className="report-tb">
                        <tbody className={"report-tbd"}>
                            {this.renderMainList()}
                        </tbody>
                    </table>
                </div>
                {modal}
            </div>
        );
    }
}
export default ReportList;


// WEBPACK FOOTER //
// ./app/components/reportComponents/reportList.js